import * as React from "react"
import { any, Action, none, loadingAsyncState, AsyncState, async, some, Option, IOWidget } from 'widgets-for-react'
import { fromJSX, SimpelPage } from '../../../../utils'
import { getParameterByName, insertUrlParam } from "../../../cms/blocks/utils.gen"
import { WordPress } from "../../../wordpress/wordpress_api"
import { VideosOverviewLayout } from "./VideosOverview.layout"
import { TaxonomyResponse } from "../PublicationLibrary/publicationLibrary.types"


export interface VideosOverviewState {
    videos: AsyncState<SimpelPage<WordPress.VideoResponse>>
    current_page: number
    countryTaxonomy: number
    topicTaxonomy: number
    topics: AsyncState<WordPress.TaxonomyResponse[]>
    countries: AsyncState<WordPress.TaxonomyResponse[]>
}

const default_page_size = 9

const get_current_page = () => {
    let page_param = getParameterByName('page')
    let current_page = 1
    if (page_param != '') {
        current_page = Number(page_param)
    }
    return current_page
}

const get_current_country = () => {
    let country = getParameterByName('country')

    return country ? Number(country) : null
}

const get_current_topic = () => {
    let topic = getParameterByName('topic')

    return topic ? Number(topic) : null
}

export const mk_VideosOverviewPageState: VideosOverviewState = {
    videos: loadingAsyncState(() => {
        let current_page = get_current_page()
        let current_country = get_current_country()
        return WordPress.api<WordPress.VideoResponse>()
        .select('video')
        .where({ per_page: default_page_size, page: current_page, brochures_taxonomy: [get_current_topic()], country_taxonomy: get_current_country() })
        .getMultiple()
        .then(data => {
            if (data.status != 200) return ({ kind: 'failed', status: data.status })
            return ({
                kind: 'result', status: data.status, value: {
                    items: data.data,
                    total_pages: Number(data.headers["x-wp-totalpages"]),
                    total_items: Number(data.headers["x-wp-total"]),
                    page_size: default_page_size,
                    current_page: current_page,
                    country_taxonomy: current_country,
                }
            })
        })
    }
    ), 
    current_page: get_current_page(),
    countryTaxonomy: get_current_country(),
    topicTaxonomy: get_current_topic(),
    topics: loadingAsyncState(() => WordPress.api<WordPress.TaxonomyResponse>()
      .where({ per_page: 99 })
      .terms('brochures_taxonomy').then(d => {
        if (d.status != 200) return ({ kind: 'failed', status: d.status })
        return ({ kind: 'result', status: d.status, value: d.data })
    })),
    countries: loadingAsyncState(() => WordPress.api<WordPress.TaxonomyResponse>()
    .where({ per_page: 99 })
    .terms('country_taxonomy').then(d => {
      if (d.status != 200) return ({ kind: 'failed', status: d.status })
      return ({ kind: 'result', status: d.status, value: d.data })
  })),
}

export const VideosOverviewWidget: IOWidget<VideosOverviewState, Action<VideosOverviewState>> = (s0) => {
    return any<Action<VideosOverviewState>>()([

        async<SimpelPage<WordPress.VideoResponse>>()(s0.videos).map(a => s2 => {
            let art = a(s2.videos)
            return ({ ...s2, videos: art, total_pages: art.kind == 'loaded' ? some(art.value.total_pages) : none() })
        }),

        async<WordPress.TaxonomyResponse[]>()(s0.topics).map(a => s => ({ ...s, topics: a(s.topics) })),
        async<WordPress.TaxonomyResponse[]>()(s0.countries).map(a => s => ({ ...s, countries: a(s.countries) })),

        fromJSX(setState => <VideosOverviewLayout
            videos={s0.videos.kind == 'loaded' ? s0.videos.value : null}
            isLoading={s0.videos.kind != 'loaded'}
            topicTaxonomy={s0.topicTaxonomy}
            countryTaxonomy={s0.countryTaxonomy}
            topics={s0.topics.kind == 'loaded' ? s0.topics.value : null}
            countries={s0.countries.kind == 'loaded' ? s0.countries.value : null}
            onTopicFilterChange={(value) => setState(s => {
                insertUrlParam('topic', value.toString())
                return ({
                    ...s, 
                    topicTaxonomy: Number(value),
                    videos: loadingAsyncState(() => WordPress.api<WordPress.VideoResponse>()
                            .select('video')
                            .where({ per_page: default_page_size, page: s.current_page as number, brochures_taxonomy: [Number(value)], country_taxonomy: s.countryTaxonomy })
                            .getMultiple()
                            .then(data => {
                                if (data.status != 200) return ({ kind: 'failed', status: data.status })
                                return ({
                                    kind: 'result', status: data.status, value: {
                                        items: data.data,
                                        total_pages: Number(data.headers["x-wp-totalpages"]),
                                        total_items: Number(data.headers["x-wp-total"]),
                                        page_size: default_page_size,
                                        current_page: s.current_page as number,
                                    }
                                })
                            })
                        )
                })
            })}
            onCountryFilterChange={(value) => setState(s => {
                insertUrlParam('country', value.toString())
                return ({
                    ...s, 
                    countryTaxonomy: Number(value),
                    videos: loadingAsyncState(() => WordPress.api<WordPress.VideoResponse>()
                            .select('video')
                            .where({ per_page: default_page_size, page: s.current_page as number, country_taxonomy: Number(value), brochures_taxonomy: [s.topicTaxonomy] })
                            .getMultiple()
                            .then(data => {
                                if (data.status != 200) return ({ kind: 'failed', status: data.status })
                                return ({
                                    kind: 'result', status: data.status, value: {
                                        items: data.data,
                                        total_pages: Number(data.headers["x-wp-totalpages"]),
                                        total_items: Number(data.headers["x-wp-total"]),
                                        page_size: default_page_size,
                                        current_page: s.current_page as number,
                                    }
                                })
                            })
                        )
                })
            })}
            onPropChange={(prop, valeu) => setState(s => {
                if (prop == 'current_page') {
                    insertUrlParam('page', valeu.toString())
                    return ({
                        ...s, [prop]: valeu,
                        videos: loadingAsyncState(() => WordPress.api<WordPress.VideoResponse>()
                            .select('video')
                            .where({ per_page: default_page_size, page: valeu as number })
                            .getMultiple()
                            .then(data => {
                                if (data.status != 200) return ({ kind: 'failed', status: data.status })
                                return ({
                                    kind: 'result', status: data.status, value: {
                                        items: data.data,
                                        total_pages: Number(data.headers["x-wp-totalpages"]),
                                        total_items: Number(data.headers["x-wp-total"]),
                                        page_size: default_page_size,
                                        current_page: valeu as number,
                                    }
                                })
                            })
                        )
                    })
                }
                return ({ ...s, [prop]: valeu })
            })}

        />)
    ])
}
